import React from 'react'

// This is
// masterquotes.estpudate
// V2 Shipment object shipment.dates.estimatedPickup

const PickupETA = ({ render, value, onChange, shipment, inputFieldsReadOnly }) => {
    if (!render) return null
    return (
        <div className="form-group col col-lg-2">
            <label>Pickup Date (ETA):</label>
            <input
                className="form-control form-control-sm"
                name="dates.estimatedPickup"
                onChange={(event) => onChange(event)}
                type="date"
                value={value}
                disabled={inputFieldsReadOnly}
            />
        </div>
    )
}

export default PickupETA
